import * as tslib_1 from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as _ from 'underscore';
import * as utils from '@ivy/fts/utils';
let Notice = class Notice extends Vue {
    constructor() {
        super(...arguments);
        this.debounceFn = _.debounce(this.scrollFn, 1000);
        this.timer = null;
        this.conStyle = {};
        this.offset = 0;
        this.duration = 0;
        this.canTransitionend = false;
    }
    textChange(newV) {
        this.timer && clearInterval(this.timer);
        // this.debounceFn()
    }
    get noticeStyle() {
        return {
            color: this.data.fontColor,
            background: this.data.bgColor,
        };
    }
    mounted() {
        this.scrollFn();
    }
    beforeDestroy() {
        this.timer && clearInterval(this.timer);
        this.timer = null;
    }
    async scrollFn(scrollBase = 0) {
        await utils.sleep(1000);
        let boxtEl = this.$el.querySelector('.text-box');
        let contentEl = this.$el.querySelector('.text-con');
        let num = contentEl.scrollWidth - boxtEl.offsetWidth;
        let scrollNum = contentEl.scrollWidth;
        const self = this;
        function firstScroll() {
            if (self.canTransitionend)
                return;
            self.conStyle = {
                transform: `translateX(-${scrollNum}px)`,
                transitionDuration: `${scrollNum / 60}s`,
            };
            setTimeout(() => {
                if (self.canTransitionend)
                    return;
                self.scrollFn(boxtEl.offsetWidth);
            }, (scrollNum / 60) * 1000 + 200);
        }
        function loopScroll() {
            if (self.canTransitionend)
                return;
            self.conStyle = {
                transform: `translateX(${scrollBase}px)`,
                transitionDuration: `0s`,
            };
            setTimeout(() => {
                const duration = (contentEl.scrollWidth + boxtEl.offsetWidth) / 60;
                self.conStyle = {
                    transform: `translateX(-${contentEl.scrollWidth}px)`,
                    transitionDuration: `${duration}s`,
                };
                setTimeout(() => {
                    if (self.canTransitionend)
                        return;
                    self.scrollFn(boxtEl.offsetWidth);
                }, duration * 1000 + 200);
            }, 300);
        }
        if (num > 0) {
            if (scrollBase) {
                loopScroll();
            }
            else {
                firstScroll();
            }
        }
        contentEl.ontransitionend = () => {
            this.canTransitionend = true;
            this.conStyle = {
                transform: `translateX(${boxtEl.offsetWidth}px)`,
                transitionDuration: `0s`,
            };
            setTimeout(() => {
                this.offset = contentEl.scrollWidth;
                this.duration = (contentEl.scrollWidth + boxtEl.offsetWidth) / 60;
                this.conStyle = {
                    transform: `translateX(-${this.offset}px)`,
                    transitionDuration: `${this.duration}s`,
                };
            }, 300);
        };
    }
};
tslib_1.__decorate([
    Prop()
], Notice.prototype, "data", void 0);
tslib_1.__decorate([
    Watch('data.content.value')
], Notice.prototype, "textChange", null);
Notice = tslib_1.__decorate([
    Component({})
], Notice);
export default Notice;
